module.exports = __webpack_public_path__ + "img/sac-rentables-ipad.3784b055.png";